<template lang="pug">
 .popup__overlay
  .popup__view
    .popup__body
      .popup__close(@click="close")
        icon(name="close")
      .popup__header(v-if="status") Электронная регистрация
      .popup__header(v-else) Отмена электронной регистрации
      .popup__main
        .cancel-label(v-if="status") Оформить электронную регистрацию для
          | {{ type && type === 'ticket' ? '&nbsp;билета' : '&nbsp;заказа' }}
        .cancel-label(v-else)
          | Вы уверены, что хотите отменить электронную регистрацию для вашего
          | {{ type && type === 'ticket' ? '&nbsp;билета' : '&nbsp;заказа' }}?

        .popup__footer.text-center
          .row(v-if="!isLoading")
            button.button.button_primary(@click="setStatus") Да
            button.button.button_primary-outline(@click="close") Отмена
          .row(v-else)
            .text-center
              spiner
  transition(name="fade" mode="out-in")
    vb-alert(v-model="error", @resolve="cancel", @close="cancel")
      template(#title) Ошибка электронной регистрации
      template() {{errorMsg}}
</template>

<script>
import icon from '@/components/Icons.vue';
import Spiner from '@/components/Spiner.vue';
import API from '@/api/api';

export default {
  props: ['orderId', 'status', 'type', 'ticketId'],
  components: {
    icon,
    Spiner,
  },
  data: () => ({
    error: false,
    errorMsg: null,
    isLoading: false,
  }),
  mounted() {
    console.log(this.orderId, this.ticketId, this.status);
  },
  methods: {
    close() {
      this.$emit('onCancel');
    },
    async setStatus() {
      this.isLoading = true;
      if (this.type === 'ticket') {
        const data = await API.setERStatusTicket(this.orderId, this.ticketId, {
          status: this.status,
        }, (err) => {
          this.commonError(err);
        });
        if (data) {
          this.cancel();
        } else {
          this.commonError();
        }
      } else {
        const data = await API.setERStatus(this.orderId, {
          status: this.status,
        }, (err) => {
          this.commonError(err);
        });
        if (data) {
          this.cancel();
        } else {
          this.commonError();
        }
      }
    },
    cancel() {
      this.isLoading = false;
      this.$emit('onCancel');
    },
    commonError(err) {
      this.isLoading = false;
      console.log('ERR', err);
      console.log(err.response.data);
      if (err.response.data.errors.length) {
        this.error = true;
        [this.errorMsg] = err.response.data.errors;
      } else {
        this.error = true;
        this.errorMsg = 'Что-то пошло не так, попробуйте позже';
      }
      // this.$emit('onCancel');
    },
  },
};
</script>

<style lang="scss">
.cancel-label{
  padding-bottom: 2rem;
}
</style>
